<style scoped>
.this__icon {
  width: 20px;
  height: 20px;
  z-index: inherit;
  position: inherit;
}
</style>
<template>
  <a-modal
    :title="null"
    :visible="!!verifyModalStatus"
    :getContainer="container"
    wrapClassName="demo__VerifyModal--con"
    dialogClass="demo__VerifyModal info"
    @cancel="closeModal"
    :footer="null"
    :mask="false"
  >
    <div class="demo__flex demo__flex-row demo__gap--8 demo__align-center">
      <img :src="verifyIcon" class="this__icon" />
      <div
        class="demo__font--20 demo__weight--600 demo__font-mobile--16 demo__color--black"
        v-if="step < 3"
      >
        {{ $t("VerifyModal.title") }}
      </div>
      <div
        class="demo__font--20 demo__weight--600 demo__font-mobile--16 demo__color--black"
        v-else
      >
        <template v-if="this.user?.current_verification?.status === 'rejected'">
          {{ $t("VerifyModal.step3.rejected.title") }}
        </template>
        <template v-else>
          {{ $t("VerifyModal.step3.processing.title") }}
        </template>
      </div>
    </div>

    <component
      :is="'Step' + step"
      :form="form"
      :verifyStatus="this.user?.current_verification?.status"
      :options="apiStatuses"
    />
    <i
      class="demo__VerifyModal--close fa-light fa-xmark fa-xl"
      @click="closeModal"
    ></i>
  </a-modal>
</template>

<script>
import { mapGetters } from "vuex";

import Step1 from "./components/Step1";
import Step2 from "./components/Step2";
import Step3 from "./components/Step3";

export default {
  components: {
    Step1,
    Step2,
    Step3,
  },
  data() {
    return {
      container: () => document.getElementById("app"),
      step: 1,
      maxStepsCount: 3,
      form: {
        professional_status: undefined,
        files: undefined,
        link: undefined,
        way: undefined,
      },
      checkIcon: require("@/assets/images/icons/checkCircleRed.svg"),
      badVerifiedIcon: require("@/assets/images/icons/crossCircleRed.svg"),
      apiStatuses: [],
    };
  },
  computed: {
    ...mapGetters(["user", "verifyModalStatus", "verifyModalInfo", "api"]),
    verifyIcon() {
      if (this.step === 3) {
        if (this.user?.current_verification?.status === "processing") {
          return this.checkIcon;
        } else if (this.user?.current_verification?.status === "rejected") {
          return this.badVerifiedIcon;
        } else return this.checkIcon;
      }
      return this.checkIcon;
    },
  },
  watch: {
    user: {
      handler(newUser) {
        if (newUser && Object.keys(newUser).length) {
          this.setDefaultForm();
        }
      },
      immediate: true,
    },
    verifyModalInfo: {
      handler(modalInfo) {
        if (modalInfo) {
          this.$nextTick(() => {
            this.form.professional_status = modalInfo.professional_status;
          });
        }
      },
      immediate: true,
    },
    verifyModalStatus: {
      handler(newStatus) {
        this.setDefaultForm();
      },
    },
  },
  created() {
    this.$accessModule("modalverify", this);
    this.$root.$on("changeVerifyStep", this.changeVerifyStep);
    this.getActualStatuses();
    this.setDefaultForm();
  },
  beforeDestroy() {
    this.$root.$off("changeVerifyStep", this.changeVerifyStep);
  },
  methods: {
    closeModal() {
      this.$store.dispatch("updateVerifyModalInfo", undefined);
      this.$store.dispatch("updateVerifyModalStatus", false);
      this.step = 1;
      this.form = {
        professional_status: undefined,
        files: undefined,
        link: undefined,
        way: undefined,
      };
    },
    setDefaultForm() {
      this.form = {
        professional_status: this.user?.professional_status?.id || undefined,
      };
      if (this.verifyModalInfo) {
        this.form.professional_status =
          this.verifyModalInfo.professional_status;
      }
      if (
        ["processing", "rejected"].includes(
          this.user?.current_verification?.status
        )
      ) {
        this.changeVerifyStep(3);
      }
    },
    changeVerifyStep(step) {
      if (step >= 1 && step <= this.maxStepsCount) {
        this.step = step;
      }
    },
    async getActualStatuses() {
      return this.api
        .getActualprofessional_statuses()
        .then((res) => {
          this.apiStatuses = res.data;
          this.$debug("Статусы загружены", "success", this.universities);
        })
        .catch((error) => {
          this.$debug("Ошибка загрузки статусов", "error", error);
        });
    },
  },
};
</script>
